module.exports = __webpack_public_path__ + "media/partners/p-and-g-a6d3c1a7.svg";